import { render, staticRenderFns } from "./ResizableBlock.vue?vue&type=template&id=1294b6db&scoped=true&"
import script from "./ResizableBlock.vue?vue&type=script&lang=ts&"
export * from "./ResizableBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableBlock.vue?vue&type=style&index=0&id=1294b6db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1294b6db",
  null
  
)

export default component.exports